import type { MessagingSendMessage201AllOfBasicInfo } from './messagingSendMessage201AllOfBasicInfo';
import type { MessagingSendMessage201AllOfSender } from './messagingSendMessage201AllOfSender';
import type { MessagingSendMessage201AllOfStatus } from './messagingSendMessage201AllOfStatus';

export type MessagingSendMessage201AllOf = {
  basicInfo?: MessagingSendMessage201AllOfBasicInfo;
  /** 발신자 정보 */
  sender?: MessagingSendMessage201AllOfSender;
  /** 메시지 상태 정보 */
  status?: MessagingSendMessage201AllOfStatus;
};
